module.exports = __webpack_public_path__ + "kelley-and-michaela-a963b2f855b5d03e18d661acab5cc1d0.webp";